define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class AgentService
     */
    function AgentService($root, $q, $log, agentProvider) {
        let self = this;

        /**
         * Search an agent
         * @param  {String} search storeId or lastname
         * @return {Promise}
         */
        self.searchAgent = function searchAgent(search) {
            return agentProvider.searchAgent(search).then(function(stores) {
                stores.forEach(store => {
                    store.horaires = _formatHours(store.horaires);
                })
                return $q.when(stores);
            });
        };

        self.getAnAgent = function(id) {
            return agentProvider.getAnAgent(id).then(function(store) {
                store[0].horaires = _formatHours(store[0].horaires);
                return $q.when(store);
            });

        };

        /**
         * Return the map objet
         * @return {object}
         */
        self.getStoreObject = function getStoreObject() {
            return {
                id: null,
                storeId: null,
                storeIdX3: null,
                emblem: null,
                storeState: null,
                storeType: null,
                addressStreet: null,
                addressPostalCode: null,
                addressCity: null,
                addressCountry: null,
                corporateName: null,
                legalForm: null,
                storeActivity: null,
                rcs: null,
                cityRcs: null,
                dateRcs: null,
                shareCapital: null,
                manualChanger: false,
                registered: false,
                mentionned: false,
                physicalPerson: true,
                oriasIntermediaireOperation: false,
                oriasConseillerInvestissements: false,
                oriasConseillerFinancement: false,
                oriasIntermediaireFinancement: false,
                oriasAgentLie: false,
                acprNumber: null,
                apeCode: null,
                accountingPhone: null,
                nim: null,
                numberPackages: null,
                shortDescription: null,
                holliday: null,
                isUpsAccessScanup: null,
                typeScanup: null,
                typeProperty: null,
                businessType: null,
                otherBusinessType: null,
                phoneNumber: null,
                years: null,
                months: null,
                isEmployee: false,
                isMoneyTransfer: false,
                isCashIn: false,
                amlComment: null,
                isRelatedEntity: false,
                relatedEntity: null,
                wuComment: null,
                agents: [
                    {
                        id: null,
                        firstName: null,
                        secondFirstName: null,
                        thirdFirstName: null,
                        fourthFirstName: null,
                        fifthFirstName: null,
                        lastName: null,
                        maidenName: null,
                        civility: '1',
                        addressStreet: null,
                        addressPostalCode: null,
                        addressCity: null,
                        addressCountry: null,
                        mobilePhone: null,
                        storePhone: null,
                        email: null,
                        termStart: null,
                        birthDate: null,
                        birthPostalCode: null,
                        birthCity: null,
                        birthCountry: null,
                        socialSecurityNumber: null,
                        quality: null,
                        formation: false,
                        active: false,
                        isLegalRepresentative: false,
                        isRfcAgent: false,
                        ocFormation: false,
                        diploma: null,
                        isUpsAppUser: false,
                        phoneModelNumber: null,
                        nationality: null,
                        isNationalId: false,
                        isResidencePermit: false,
                        isPassport: false,
                        nationalIdNumber: null,
                        residencePermitNumber: null,
                        passportNumber: null,
                        nationalIdCountry: null,
                        residencePermitCountry: null,
                        passportCountry: null,
                        nationalIdExpiration: null,
                        residencePermitExpiration: null,
                        passportExpiration: null,
                        iceFullName: null,
                        iceRelationship: null,
                        iceFullAddress: null,
                        icePhone: null,
                        experiences: [],
                        certificate: null,
                        otherCertificate: null,
                        majorIn: null,
                        language1: null,
                        language2: null,
                        language3: null,
                        languageLevel1: null,
                        languageLevel2: null,
                        languageLevel3: null,
                        shareCapital: null,
                        isFinancialSector: false,
                        financialSectorDescription: null,
                        isLicensedByRegulatorBody: false,
                        isMoneyTransfer: false,
                        isCashIn: false,
                        isAlreadyDoTa: false,
                        isAlreadyStopTa: false,
                        principalContact: true,
                        complianceDelegate: true,
                        operator: true,
                        authorizedSignatory: true,
                        isDecisionMaker: true,
                        isOldAddress: false,
                        comment: null,
                        oldAddress: null,
                        relatedIndividuals: null,
                        regulators: []
                    }
                ],
                horaires: []
            };
        };

        /**
         * Return the map objet
         * @return {object}
         */
        self.getAgentObject = function getAgentObject() {
            return {
                id: null,
                firstName: null,
                secondFirstName: null,
                thirdFirstName: null,
                fourthFirstName: null,
                fifthFirstName: null,
                lastName: null,
                maidenName: null,
                civility: '1',
                addressStreet: null,
                addressPostalCode: null,
                addressCity: null,
                addressCountry: null,
                mobilePhone: null,
                storePhone: null,
                email: null,
                socialSecurityNumber: null,
                termStart: null,
                birthDate: null,
                birthPostalCode: null,
                birthCity: null,
                birthCountry: null,
                quality: null,
                formation: false,
                active: true,
                isLegalRepresentative: false,
                isRfcAgent: false,
                ocFormation: false,
                diploma: null,
                isUpsAppUser: false,
                phoneModelNumber: null,
                nationality: null,
                isNationalId: false,
                isResidencePermit: false,
                isPassport: false,
                nationalIdNumber: null,
                residencePermitNumber: null,
                passportNumber: null,
                nationalIdCountry: null,
                residencePermitCountry: null,
                passportCountry: null,
                nationalIdExpiration: null,
                residencePermitExpiration: null,
                passportExpiration: null,
                iceFullName: null,
                iceRelationship: null,
                iceFullAddress: null,
                icePhone: null,
                experiences: [],
                certificate: null,
                otherCertificate: null,
                majorIn: null,
                language1: null,
                language2: null,
                language3: null,
                languageLevel1: null,
                languageLevel2: null,
                languageLevel3: null,
                shareCapital: null,
                isFinancialSector: false,
                financialSectorDescription: null,
                isLicensedByRegulatorBody: false,
                isAlreadyDoTa: false,
                isAlreadyStopTa: false,
                principalContact: true,
                complianceDelegate: true,
                operator: true,
                authorizedSignatory: true,
                isDecisionMaker: true,
                isOldAddress: false,
                comment: null,
                oldAddress: null,
                relatedIndividuals: null,
                regulators: []
            };
        };

        /**
         * Create or update an agent
         * @param  {Object} data
         * @return {Promise}
         */
        self.createUpdate = function createUpdate(data) {
            return agentProvider.createUpdate(data).then(function(agent) {
                agent[0].horaires = _formatHours(agent[0].horaires);
                return $q.when(agent);
            });
        };

        self.getDistinctActivities = function() {
            return agentProvider.getDistinctActivities().then(function(res) {
                return res;
            });
        };

        self.getDistinctTypes = function() {
            return agentProvider.getDistinctTypes().then(function(res) {
                return res;
            });
        };

        function _formatHours(data) {
            data.map((jour) => {
                jour.morningOpen = jour.morningOpen
                    ? new Date(moment(jour.morningOpen, 'HH:mm'))
                    : null;
                jour.morningClose = jour.morningClose
                    ? new Date(moment(jour.morningClose, 'HH:mm'))
                    : null;
                jour.afternoonOpen = jour.afternoonOpen
                    ? new Date(moment(jour.afternoonOpen, 'HH:mm'))
                    : null;
                jour.afternoonClose = jour.afternoonClose
                    ? new Date(moment(jour.afternoonClose, 'HH:mm'))
                    : null;
            });
            return data;
        }

        self.deleteExperience = function(id) {
            return agentProvider.deleteExperience(id).then(function(res) {
                return res;
            });
        };

        return self;
    }

    AgentService.$inject = ['$rootScope', '$q', '$log', 'agent'];

    angular.module('app.kya.list.agentService', []).factory('agentService', AgentService);
});
